/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.facebook = function facebook($window, Gon, ThirdPartyLoaderService) {
        $window.fbAsyncInit = function() {
            $window.FB.init({
                appId      : Gon.facebook_app_id, // App ID
                status     : true, // check login status
                cookie     : true, // enable cookies to allow the server to access the session
                xfbml      : true, // parse XFBML
                version    : 'v2.12'
            });
        };

        return ThirdPartyLoaderService.loadUrlPromise('https://connect.facebook.net/en_US/sdk.js', function() {return $window.FB;}, 'facebook-jssdk');
    };
}());
